import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/efashion_Logotype_Noir 1.png'


const _hoisted_1 = { class: "w-full max-w-6xl bg-white rounded-xl shadow-lg" }
const _hoisted_2 = { class: "text-center p-8 border-b border-gray-100" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "p-8" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["type", "value"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-xs text-red-600 mb-0"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-1 text-xs text-gray-500 mb-0"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = ["type", "value"]
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_16 = { class: "space-y-6" }
const _hoisted_17 = { class: "space-y-6" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_19 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_21 = { class: "space-y-4 pt-10" }
const _hoisted_22 = { class: "flex items-start" }
const _hoisted_23 = ["checked"]

import { ref } from "vue";
import type { PropType } from 'vue';
import {
  StepperHeader,
  Step,
  RegisterFormField,
  BrandSelectorField,
  PhoneField,
  EmailField,
  DateField,
  FileUploadField,
  ProductCategoriesField,
  PriceRangeField,
  FormSummary,
  StepNavigation,
  BankingInfoField,
  AccountTitleField,
  AddressAutocompleteField,
} from "@/components";
import type {
  SellerRegistrationFormProps,
  PriceRange,
  SellerRegisterForm,
  StepperStep,
} from "../../types/sellerRegister";

// const props = defineProps<SellerRegistrationFormProps>();
const MIN_PASSWORD_LENGTH = 6;

/**
 * Valide mot de passe et confirmation. Utilise les valeurs passées en priorité
 * pour éviter le décalage d'un caractère (props pas encore à jour après emit).
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'SellerRegistrationForm',
  props: {
  registerForm: {
    type: Object as PropType<SellerRegisterForm>,
    required: true,
  },
  steps: {
    type: Array as PropType<StepperStep[]>,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
  canProceedToNextStep: {
    type: Boolean,
    required: true,
  },
  canSubmit: {
    type: Boolean,
    required: true,
  },
  signature: {
    type: String,
    required: false,
  },
},
  emits: ["register", "previous-step", "next-step", "field-validation-changed", "date-validation-changed", "banking-validation-changed", "update:register-form", "update:price-range", "update:banking-info", "update:logo-file", "address-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

// Mot de passe : affichage et validation (6 caractères min, confirmation identique)
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const passwordError = ref("");
const confirmPasswordError = ref("");

function validatePasswordAndEmit(justTyped?: {
  password?: string;
  confirmPassword?: string;
}) {
  const rawPassword = justTyped?.password ?? props.registerForm.password ?? "";
  const rawConfirm =
    justTyped?.confirmPassword ?? props.registerForm.confirmPassword ?? "";
  const p = rawPassword.trim();
  const c = rawConfirm.trim();

  // Validation mot de passe : au moins 6 caractères (après trim)
  let pValid = false;
  if (!rawPassword || rawPassword.length === 0) {
    passwordError.value = "";
  } else if (p.length < MIN_PASSWORD_LENGTH) {
    passwordError.value = `Le mot de passe doit contenir au moins ${MIN_PASSWORD_LENGTH} caractères`;
  } else {
    passwordError.value = "";
    pValid = true;
  }

  // Validation confirmation : doit être identique au mot de passe (comparaison après trim)
  let cValid = false;
  if (!rawConfirm || rawConfirm.length === 0) {
    confirmPasswordError.value = "";
  } else if (!pValid) {
    confirmPasswordError.value =
      "Remplissez d'abord le mot de passe ci-dessus (6 caractères min.)";
  } else if (p !== c) {
    confirmPasswordError.value = "Les deux mots de passe ne correspondent pas";
  } else {
    confirmPasswordError.value = "";
    cValid = true;
  }

  emit("field-validation-changed", "password", pValid);
  emit("field-validation-changed", "confirmPassword", cValid);
}

function onPasswordInput(e: Event) {
  const value = (e.target as HTMLInputElement).value;
  updateRegisterFormField("password", value);
  validatePasswordAndEmit({ password: value });
}

function onConfirmPasswordInput(e: Event) {
  const value = (e.target as HTMLInputElement).value;
  updateRegisterFormField("confirmPassword", value);
  validatePasswordAndEmit({ confirmPassword: value });
}

const emit = __emit;

// Méthodes
const handleRegister = () => {
  emit("register");
};

const updateRegisterFormField = (fieldName: string, value: any) => {
  const updatedForm = { ...props.registerForm, [fieldName]: value };
  emit("update:register-form", updatedForm);
};

// Ces fonctions ne sont plus nécessaires car tout est maintenant dans registerForm

const handleAddressSelected = (address: {
  streetAddress: string;
  streetName   : string;
  streetNumber : string;
  postalCode   : string;
  city         : string;
  fullAddress  : string;
}) => {
  // Créer un formulaire mis à jour avec tous les champs d'adresse
  // console.log(address)
  const updatedForm = {
    ...props.registerForm,
    streetAddress : address.streetName,
    streetNumber  : address.streetNumber,
    postalCode    : address.postalCode,
    city          : address.city,
  };

  // Émettre un seul événement avec tous les champs mis à jour
  emit("update:register-form", updatedForm);
};

const previousStep = () => {
  emit("previous-step");
};

const nextStep = () => {
  emit("next-step");
};

const onFieldValidationChanged = (fieldName: string, isValid: boolean) => {
  emit("field-validation-changed", fieldName, isValid);
};

const onDateValidationChanged = (isValid: boolean) => {
  emit("date-validation-changed", isValid);
};

// Cette fonction n'est plus nécessaire car les informations bancaires sont maintenant dans registerForm

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"flex justify-center mb-6\"><img src=\"" + _imports_0 + "\" alt=\"Efashion Logo\" class=\"h-12 w-auto\"></div><h1 class=\"text-3xl font-bold text-gray-900 mb-2\">Devenir Grossiste</h1><p class=\"text-lg text-gray-600 mb-2\"> Formulaire d&#39;inscription grossiste </p><p class=\"text-gray-500\"> Rejoignez le plus grand catalogue de mode B2B en ligne de Paris ! </p>", 4)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/auth",
          class: "inline-flex items-center text-sm text-blue-600 hover:text-blue-500 font-medium"
        }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1),
            _createTextVNode(" Retour à la connexion ")
          ])),
          _: 1,
          __: [42]
        })
      ])
    ]),
    _createVNode(_unref(StepperHeader), {
      steps: __props.steps,
      "current-step": __props.currentStep
    }, null, 8, ["steps", "current-step"]),
    _cache[48] || (_cache[48] = _createStaticVNode("<div class=\"bg-blue-50 border-b border-blue-200 px-8 pt-3\"><div class=\"max-w-6xl mx-auto\"><p class=\"text-sm text-blue-800 flex flex-col sm:flex-row items-center sm:items-start justify-center sm:justify-start\"><span class=\"flex items-center mb-2 sm:mb-0\"><i class=\"fas fa-info-circle mr-2\"></i><span class=\"font-medium pr-1\">Information :</span></span><span>Les champs marqués d&#39;un <span class=\"text-red-500 font-bold px-1\">*</span> sont obligatoires</span></p></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleRegister, ["prevent"])
      }, [
        _createVNode(_unref(Step), {
          "step-number": 1,
          title: "INFORMATION DU GROSSISTE",
          "is-active": __props.currentStep === 0
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(RegisterFormField), {
                type: "text",
                label: "Dénomination société",
                required: "",
                placeholder: "Nom de votre société",
                "model-value": __props.registerForm.companyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => updateRegisterFormField('companyName', value))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(RegisterFormField), {
                type: "text",
                label: "SIRET",
                required: "",
                placeholder: "Numéro SIRET (14 chiffres)",
                "model-value": __props.registerForm.siret,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => updateRegisterFormField('siret', value)),
                error: __props.registerForm.siret && !/^\d{14}$/.test(__props.registerForm.siret) ?  'Le SIRET doit contenir exactement 14 chiffres' : ''
              }, null, 8, ["model-value", "error"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(RegisterFormField), {
                type: "text",
                label: "Nom du contact principal",
                required: "",
                placeholder: "Nom du contact principal",
                "model-value": __props.registerForm.contactName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => updateRegisterFormField('contactName', value))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(RegisterFormField), {
                type: "text",
                label: "Prénom",
                required: "",
                placeholder: "Prénom",
                "model-value": __props.registerForm.firstName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => updateRegisterFormField('firstName', value))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(PhoneField), {
                label: "Numéro téléphone",
                required: "",
                placeholder: "Numéro de téléphone",
                "model-value": __props.registerForm.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => updateRegisterFormField('phone', value)),
                validationType: "phone",
                onValidationChanged: _cache[5] || (_cache[5] = (isValid) => onFieldValidationChanged('phone', isValid))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(EmailField), {
                label: "Email",
                required: "",
                placeholder: "Email",
                "model-value": __props.registerForm.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => updateRegisterFormField('email', value)),
                onValidationChanged: _cache[7] || (_cache[7] = (isValid) => onFieldValidationChanged('email', isValid))
              }, null, 8, ["model-value"]),
              _createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, [
                  _createTextVNode(" Mot de passe "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    type: showPassword.value ? 'text' : 'password',
                    value: __props.registerForm.password,
                    placeholder: "Minimum 6 caractères",
                    minlength: "6",
                    class: _normalizeClass(["w-full h-9 px-3 pr-10 text-sm border rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors", passwordError.value ? 'border-red-300' : 'border-gray-300']),
                    onInput: onPasswordInput
                  }, null, 42, _hoisted_8),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 pr-3 flex items-center",
                    "aria-label": 
                    showPassword.value
                      ? 'Masquer le mot de passe'
                      : 'Afficher le mot de passe'
                  
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([showPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye', "text-gray-400 hover:text-gray-600"])
                    }, null, 2)
                  ], 8, _hoisted_9)
                ]),
                (passwordError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(passwordError.value), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, " Minimum 6 caractères "))
              ]),
              _createElementVNode("div", null, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, [
                  _createTextVNode(" Veuillez confirmer votre mot de passe "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("input", {
                    type: showConfirmPassword.value ? 'text' : 'password',
                    value: __props.registerForm.confirmPassword,
                    placeholder: "Confirmez votre mot de passe",
                    class: _normalizeClass(["w-full h-9 px-3 pr-10 text-sm border rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors", 
                    confirmPasswordError.value ? 'border-red-300' : 'border-gray-300'
                  ]),
                    onInput: onConfirmPasswordInput
                  }, null, 42, _hoisted_13),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                    class: "absolute inset-y-0 right-0 pr-3 flex items-center",
                    "aria-label": 
                    showConfirmPassword.value
                      ? 'Masquer le mot de passe'
                      : 'Afficher le mot de passe'
                  
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([
                      showConfirmPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye'
                    , "text-gray-400 hover:text-gray-600"])
                    }, null, 2)
                  ], 8, _hoisted_14)
                ]),
                (confirmPasswordError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(confirmPasswordError.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(PhoneField), {
                label: "Téléphone portable",
                required: "",
                placeholder: "Téléphone portable",
                "model-value": __props.registerForm.mobile,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = (value) => updateRegisterFormField('mobile', value)),
                validationType: "mobile",
                onValidationChanged: _cache[11] || (_cache[11] = (isValid) => onFieldValidationChanged('mobile', isValid))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(PhoneField), {
                label: "Fax (Optionnel)",
                placeholder: "Numéro de fax",
                "model-value": __props.registerForm.fax,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = (value) => updateRegisterFormField('fax', value)),
                validationType: "fax",
                onValidationChanged: _cache[13] || (_cache[13] = (isValid) => onFieldValidationChanged('fax', isValid))
              }, null, 8, ["model-value"]),
              _createElementVNode("div", null, [
                _createVNode(_unref(RegisterFormField), {
                  type: "text",
                  label: "Nom de Marque",
                  required: "",
                  placeholder: "Saisir une marque...",
                  "model-value": __props.registerForm.brand,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = (value) => updateRegisterFormField('brand', value))
                }, null, 8, ["model-value"])
              ]),
              _createVNode(_unref(DateField), {
                label: "Date de création de la boutique",
                required: "",
                "model-value": __props.registerForm.creationDate,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = (value) => updateRegisterFormField('creationDate', value)),
                "help-text": "Sélectionnez la date de création de votre entreprise",
                "min-date": '1900-01-01',
                "max-date": new Date().toISOString().split('T')[0],
                "show-validation-info": true,
                onValidationChanged: onDateValidationChanged
              }, null, 8, ["model-value", "max-date"])
            ])
          ]),
          _: 1
        }, 8, ["is-active"]),
        _createVNode(_unref(Step), {
          "step-number": 2,
          title: "ADRESSE PRINCIPALE DU MAGASIN",
          "is-active": __props.currentStep === 1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createVNode(_unref(AddressAutocompleteField), {
                  "model-value": __props.registerForm.streetAddress,
                  "postal-code": __props.registerForm.postalCode,
                  city: __props.registerForm.city,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = (value) => updateRegisterFormField('streetAddress', value)),
                  "onUpdate:postalCode": _cache[17] || (_cache[17] = (value) => updateRegisterFormField('postalCode', value)),
                  "onUpdate:city": _cache[18] || (_cache[18] = (value) => updateRegisterFormField('city', value)),
                  onAddressSelected: handleAddressSelected,
                  onPostalValidationChanged: _cache[19] || (_cache[19] = (isValid) => onFieldValidationChanged('postalCode', isValid))
                }, null, 8, ["model-value", "postal-code", "city"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(RegisterFormField), {
                  type: "text",
                  label: "Complément d'adresse (Optionnel)",
                  placeholder: "Bâtiment , Lot , etc...",
                  "model-value": __props.registerForm.addressComplement,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = (value) => updateRegisterFormField('addressComplement', value))
                }, null, 8, ["model-value"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["is-active"]),
        _createVNode(_unref(Step), {
          "step-number": 3,
          title: "INFORMATIONS D'AFFAIRES",
          "is-active": __props.currentStep === 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _cache[46] || (_cache[46] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 mb-4" }, " Documents légaux ", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(FileUploadField), {
                    label: "KBIS",
                    required: "",
                    accept: ".pdf,.jpg,.jpeg,.png",
                    "help-text": "Document légal de votre entreprise",
                    "model-value": __props.registerForm.kbis,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = (value) => updateRegisterFormField('kbis', value)),
                    onValidationChanged: _cache[22] || (_cache[22] = (isValid) => onFieldValidationChanged('kbis', isValid))
                  }, null, 8, ["model-value"]),
                  _createVNode(_unref(FileUploadField), {
                    label: "Pièce d'identité du gérant",
                    required: "",
                    accept: ".pdf,.jpg,.jpeg,.png",
                    "help-text": "Carte d'identité ou passeport du gérant",
                    "model-value": __props.registerForm.idGerant,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = (value) => updateRegisterFormField('idGerant', value)),
                    onValidationChanged: _cache[24] || (_cache[24] = (isValid) => onFieldValidationChanged('idGerant', isValid))
                  }, null, 8, ["model-value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(AccountTitleField), {
                  label: "Titulaire du compte",
                  required: "",
                  placeholder: "Nom du titulaire du compte",
                  "model-value": __props.registerForm.accountTitle,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = (value) => updateRegisterFormField('accountTitle', value)),
                  onValidationChanged: _cache[26] || (_cache[26] = (isValid) => onFieldValidationChanged('accountTitle', isValid))
                }, null, 8, ["model-value"]),
                _createVNode(_unref(BankingInfoField), {
                  label: "Numéro IBAN",
                  type: "iban",
                  required: "",
                  "model-value": __props.registerForm.iban,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = (value) => updateRegisterFormField('iban', value)),
                  onValidationChanged: _cache[28] || (_cache[28] = (field, isValid) => onFieldValidationChanged(field, isValid))
                }, null, 8, ["model-value"]),
                _createVNode(_unref(RegisterFormField), {
                  type: "text",
                  label: "Code BIC",
                  placeholder: "Code BIC de votre banque",
                  "model-value": __props.registerForm.bic,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = (value) => updateRegisterFormField('bic', value))
                }, null, 8, ["model-value"]),
                _createVNode(_unref(BankingInfoField), {
                  label: "Numéro de TVA",
                  type: "tva",
                  required: "",
                  "model-value": __props.registerForm.vat,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = (value) => updateRegisterFormField('vat', value)),
                  onValidationChanged: _cache[31] || (_cache[31] = (field, isValid) => onFieldValidationChanged(field, isValid))
                }, null, 8, ["model-value"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["is-active"]),
        _createVNode(_unref(Step), {
          "step-number": 4,
          title: "DÉTAILS DU BUSINESS",
          "is-active": __props.currentStep === 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(FileUploadField), {
                label: "Logo (Optionnel)",
                accept: ".jpg,.jpeg,.png",
                "help-text": "Logo de votre entreprise",
                "model-value": __props.registerForm.logoFile,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = (value) => updateRegisterFormField('logoFile', value))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(ProductCategoriesField), {
                label: "Catégories de produits",
                required: "",
                "model-value": __props.registerForm.productCategories,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = (value) => updateRegisterFormField('productCategories', value)),
                onValidationChanged: _cache[34] || (_cache[34] = (isValid) => onFieldValidationChanged('productCategories', isValid))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(RegisterFormField), {
                type: "number",
                label: "Commande minimum (€)",
                required: "",
                placeholder: "Montant minimum",
                "model-value": __props.registerForm.minOrder,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = (value) => updateRegisterFormField('minOrder', value)),
                onValidationChanged: _cache[36] || (_cache[36] = (isValid) => onFieldValidationChanged('minOrder', isValid))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(RegisterFormField), {
                type: "text",
                label: "Site web (Optionnel)",
                placeholder: "https://www.votre-site.com",
                "model-value": __props.registerForm.website,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = (value) => updateRegisterFormField('website', value))
              }, null, 8, ["model-value"]),
              _createVNode(_unref(PriceRangeField), {
                label: "Gamme de prix",
                "model-value": __props.registerForm.priceRange,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = (value) => updateRegisterFormField('priceRange', value)),
                min: 0,
                max: 200,
                step: 10,
                "grid-class": "md:col-span-2"
              }, null, 8, ["model-value"]),
              _createVNode(_unref(RegisterFormField), {
                type: "textarea",
                label: "Description (50 caractères minimum)",
                placeholder: "-- Veuillez mettre votre description --",
                "model-value": __props.registerForm.description,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = (value) => updateRegisterFormField('description', value)),
                rows: 4,
                "grid-class": "md:col-span-2",
                "min-length": 50,
                "max-length": 510,
                required: "",
                onValidationChanged: _cache[40] || (_cache[40] = ($event: any) => (
                onFieldValidationChanged('description', $event)
              ))
              }, null, 8, ["model-value"])
            ])
          ]),
          _: 1
        }, 8, ["is-active"]),
        _createVNode(_unref(Step), {
          "step-number": 5,
          title: "VALIDATION FINALE",
          "is-active": __props.currentStep === 4
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormSummary), {
              title: "Résumé de votre inscription",
              subtitle: "Vérifiez les informations avant de soumettre",
              data: __props.registerForm,
              "price-range": __props.registerForm.priceRange,
              "banking-info": {
              iban: __props.registerForm.iban,
              tva: __props.registerForm.vat,
              accountTitle: __props.registerForm.accountTitle,
            },
              "logo-file": __props.registerForm.logoFile
            }, null, 8, ["data", "price-range", "banking-info", "logo-file"]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createElementVNode("input", {
                  checked: __props.registerForm.terms,
                  onChange: _cache[41] || (_cache[41] = (event) => updateRegisterFormField('terms', (event.target as HTMLInputElement).checked)),
                  type: "checkbox",
                  required: "",
                  class: "h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
                }, null, 40, _hoisted_23),
                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "ml-3 text-sm text-gray-700" }, [
                  _createTextVNode(" En cochant cette case, vous acceptez nos "),
                  _createElementVNode("a", {
                    href: "https://www.efashion-paris.com/pages-cguv-vendeurs",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "text-red-500 font-medium hover:text-red-700 underline cursor-pointer"
                  }, " conditions générales d'utilisations ")
                ], -1))
              ])
            ])
          ]),
          _: 1
        }, 8, ["is-active"]),
        _createVNode(_unref(StepNavigation), {
          "current-step": __props.currentStep,
          "total-steps": __props.steps.length,
          "can-proceed": __props.canProceedToNextStep,
          "can-submit": __props.canSubmit,
          "is-loading": __props.isLoading,
          "submit-label": "Créer mon compte grossiste",
          onPrevious: previousStep,
          onNext: nextStep
        }, null, 8, ["current-step", "total-steps", "can-proceed", "can-submit", "is-loading"])
      ], 32)
    ])
  ]))
}
}

})